import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "../utils/RouteConstant";

const ProtectedRoutes = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      navigate(LOGIN);
    }
  }, [navigate]);

  return children;
};

export default ProtectedRoutes;